<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<p class="calibre3"><span id="pgepubid00065" title="[53]"><a id="Page_53" title="[53]"></a></span></p>
<h2 class="calibre" id="pgepubid00066">CHAPTER VI.<br class="calibre16"/>
<span class="cheaderfont">DEED AND DREAM.</span></h2>
<p class="pcalibre drop-capi-m">WHEN Olga went to her room that night in St.
Petersburg, instead of going to bed, she unpacked
from her valise a series of articles which seemed
strange possessions for a young girl of not quite
seventeen to travel with on her wedding journey.</p>
<p class="calibre3">First came a tiny spirit furnace from which, by the aid of
an arrangement something like the modern blow-pipe, an intense
heat could be obtained. Then a delicate pair of scales, a
glass pestle and mortar, and a couple of glass liquid-measures,
and lastly, half a dozen little phials filled with variously-coloured
liquids, and as many little packets of powders, that
looked like herbs ground very finely.</p>
<p class="calibre3">When she had placed these out on the table, after having
carefully locked the door of her room, and seen that the
windows were completely shuttered and curtained, she drew
from the bosom of her dress a gold chain, at the end of which
was fastened, together with the key of the secret recess in the
wall of the turret chamber of the house at Hampstead, a small
bag of silk, out of which she took a little roll of parchment,—the
slip which she had abstracted from Paul Romanoff’s secret will
after she had persuaded Serge, with her false kisses, to leave her
alone for a while.</p>
<p class="calibre3">She seated herself at the table, drew the electric reading-lamp
which stood on it close to her, laid the slip down in front
of her, keeping it unrolled by means of a couple of little<span id="pgepubid00067" title="[54]"><a id="Page_54" title="[54]"></a></span>
weights, and studied it intently for several minutes. Then
she made a series of calculations on another sheet of paper,
and compared the result carefully with some figures on the
slip.</p>
<p class="calibre3">She made them three times over before she was satisfied
that they were absolutely correct, and then, with all the care
and deliberation of a chemical analyst performing a delicate
and important experiment, she proceeded to weigh out tiny
quantities of the powders, and to mix them very carefully in
the little glass mortar. This done, she emptied the mixture
into a little platinum crucible, which she placed on the furnace,
at the same time applying a gentle heat.</p>
<p class="calibre3">Then she turned her attention to the phials, measuring off
quantities of their contents with the most scrupulous exactitude,
mixing them two and two, and adding this mixture to a
third, and so on, in a certain order which was evidently prearranged,
as she constantly referred to the slip of parchment
and her own calculations as she was mixing them.</p>
<p class="calibre3">By the time she finished this part of her work, she had
obtained from the various coloured liquids one perfectly colourless
and odourless, of a specific gravity apparently considerably
in excess of that of water, although, at the same time, it was
extremely mobile and refractive. She held it up to the light,
looking at it with her eyelids somewhat screwed up, and with
a cruel smile on her pretty lips.</p>
<p class="calibre3">“So far, so good,” she said in a voice little higher than a
whisper. “The lives of fifty strong men in that couple of
ounces of harmless looking fluid! If anyone could see me just
now, I fancy they would take me rather for a witch or a
poisoner of the fifteenth century than for a girl of the twenty-first.</p>
<p class="calibre3">“Well, my friend Alan, your mysterious power may kill
more quickly, but not more surely than this; and this, too,
will take a man out of the world so easily that not even he
himself will know that he is going,—not even when he sinks into
the sleep from which he will awake on the other side of the
shadows.</p>
<p class="calibre3"><span id="pgepubid00068" title="[55]"><a id="Page_55" title="[55]"></a></span></p>
<p class="calibre3">“So much for the bodies of our enemies, and now for their
souls! I don’t want to kill wholesale, at least, not just yet;
and as for you, my Alan, you are far too splendid, too glorious
a man to be killed, to say nothing of your being so much more
useful alive. No, I have a very much pleasanter fate in store
for you.”</p>
<p class="calibre3">Just then a little cloud as of incense smoke began to rise
from the crucible in which were the mixed powders, and a
faint, pleasant perfume began to diffuse itself. She stopped
her soliloquy, measured off exactly half of the liquid, and
patiently poured it, drop by drop, into the crucible, at the
same time gradually increasing the heat.</p>
<p class="calibre3">The vapour gradually disappeared, and the perfume died
away. When she had poured in the last drop, she began
slowly stirring the mixture with a glass rod. It gradually
assumed the consistency of thick syrup, and after stirring it
for three minutes by her watch, which lay on the table beside
her, she extinguished the electric lamp and waited.</p>
<p class="calibre3">In a few seconds a pale, orange-coloured flame appeared
hovering over the crucible. As its ghostly light fell upon her
anxious features, she caught sight of herself in a mirror let into
the wall on the opposite side of the table. She started back in
her chair with an irrepressible shudder. For the first time in
her life she saw herself as she really was.</p>
<p class="calibre3">The weird, unearthly light of the flame changed the clear,
pale olive of her skin into a sallow red, and cast what looked
like a mist of vapour tinged with blood across the dark lustre
of her dusky eyes. It seemed as though the light that she
had called forth from the darkness had melted the beautiful
mask which hid her inner self from the eyes of men, and
revealed her naked soul incarnate in the evil shape that should
have belonged to it.</p>
<p class="calibre3">Suddenly the flame vanished, she turned on the switch of
the lamp, placed a platinum cover over the crucible with a
pair of light, curved tongs, and, with a quick half-turn, screwed
it hermetically down. Then she turned the heat of the furnace
on to the full, rose from her chair, and stretched herself, with<span id="pgepubid00069" title="[56]"><a id="Page_56" title="[56]"></a></span>
her linked hands above her head, till her lithe, girlish form was
drawn up to its full height in front of the mirror.</p>
<p class="calibre3">She looked dreamily from under her half-closed lids at
the perfect picture presented by the reflection, and then her
tightly-closed lips melted into a smile, and she said softly to
herself—</p>
<p class="calibre3">“Ah, that is a different sort of picture. I wonder what
Alan would have thought if he could have seen <em class="calibre14">that</em> one?
I don’t think I should have taken my trip in the air-ship to-morrow
if he had done. Well, I have seen myself as I am—what
four generations of inherited hate and longing for revenge
have made me.</p>
<p class="calibre3">“In the light of that horrible flame I might have sat for the
portrait of the lost soul of Lucrezia Borghia. Ah, well, if mine
is lost, it shall be lost for something worth the exchange.
‘Better to rule in Hell than serve in Heaven,’ as old Milton
said, and after all—who knows?</p>
<p class="calibre3">“Bah! that is enough of dreaming, when the time for doing
is so near. I must get some sleep to-night, or my eyes will
have lost some of their brightness by to-morrow.”</p>
<p class="calibre3">So saying, she busied herself putting away her phials, and
powders, and apparatus. The half of the colourless liquid she
had left she carefully decanted into a tiny flask, over the
stopper of which she screwed a silver cap that had a little ring
on the top, and this she hung on the chain round her neck.
She replaced the slip of parchment in its silken bag, and carefully
burnt the paper on which she had made her calculations.</p>
<p class="calibre3">By this time the bottom of the crucible was glowing red
hot. She noted the time that had elapsed since she had
screwed the cap down, waited five minutes longer, and then
extinguished the furnace, undressed, and got into bed, and in
half an hour was sleeping as quietly as a little child. She had
set the chime of her repeating watch to sound at six, and hung
the watch close above her head.</p>
<p class="calibre3">Calm as her sleep was at first, it was by no means dreamless,
and her dreams were well fitted to be those of a guilty soul
slumbering after a work of death.</p>
<p class="calibre3"><span id="pgepubid00070" title="[57]"><a id="Page_57" title="[57]"></a></span></p>
<p class="calibre3">She saw herself standing with Alan on the glass-domed deck
of the air-ship, beneath the light of a clear, white moon sailing
high in the heavens, and a host of brilliant stars glittering out
of the deep-blue depths beyond it. Far below them lay an
unbroken cloud-sea of dazzling whiteness, which stretched away
into the infinite distance on all sides, until it seemed to blend
with the moonlight and melt into the sky.</p>
<p class="calibre3">Then the scene changed, and the air-ship swept downwards
in a wide, spiral curve, and plunged through the noiseless
billows of the shadowy sea. As she did so, a fearful chorus of
sounds rose up from the earth below.</p>
<p class="calibre3">The moonlight and starlight were gone, and in their place
the lurid glare of burning cities and blazing forests cast a fearful
radiance up through the great eddying waves of smoke, and
reflected itself on the under surface of the clouds; now the air-ship
swept hither and thither with bewildering rapidity, like
the incarnation of some fearful spirit of destruction. Alan had
vanished, and she was giving orders rapidly, and men were
working the long, slender guns in a grim silence that contrasted
weirdly with the horrible din that rose from the earth.</p>
<p class="calibre3">She saw neither smoke nor flame from the guns, nor heard
any sound as they were discharged, but every time she raised
her hand, the motion was followed within a few seconds by a
shaking of the atmosphere, a dull roar from the earth, and the
outburst of vast, dazzling masses of flame, before which the
blaze of the conflagration paled.</p>
<p class="calibre3">She looked down with fierce exultation upon the scene of
carnage and destruction; and <a id="Ref_57"></a>as she gazed upon it, the fires
died away, the roar of the explosions began to sound like
echoes in the distance, and when the landscape of her dreamland
took definite shape again, the air-ship was hovering over
a vast, oval valley, walled in by mighty mountain masses, surmounted
by towering peaks, on some of which crests of everlasting
snow and ice shone undissolved in the rays of the
tropical sun.</p>
<div class="figcenter5" id="Fig_57">
<img alt="" class="calibre13" id="id-1620495644090115139" src="Images/img0008.jpg"/>
<div class="caption" id="ebm_caption2"><p class="center1"><span class="smcap">As she gazed upon it, the Fires died away.</span>
</p>
</div>
</div>
<p class="calibre3">The valley itself was of such incomparable and fairy-like
beauty, that it seemed to belong rather to the realm of<span id="pgepubid00071" title="[58]"><a id="Page_58" title="[58]"></a></span>
imagination than to the world of reality. A great lake lay in
the centre, its emerald shores lined with groves of palms and
orange-trees, and fringed with verdant islets spangled with
many coloured flowers.</p>
<p class="calibre3">On the northern shore of the lake lay a splendid city of
marble palaces, surrounded by shady gardens, and divided from
each other by broad, straight streets, smooth as ivory and spotless
as snow, and lined with double rows of wide-spreading
trees, which cast a pleasant shade along their sides.</p>
<p class="calibre3">In the midst of a vast square, in the centre of the city,
rose an immense building of marble of perfect whiteness,
surmounted by a great golden dome, which in turn was
crowned by the silver shape of a woman with great spreading
wings, which blazed and scintillated in the sunlight as though
they had been fashioned of sheets of crystal, pure and translucent
as diamonds.</p>
<p class="calibre3">All over the valley, villas and palaces of marble were
scattered in cool ravines and on shaded, wooded slopes; and as
far as her eye could reach, vast expanses of garden land,
emerald pastures, and golden corn fields stretched away over
hill and vale, until the most remote were met by the cool, dark
forests which clothed the middle slopes of the all-encircling
mountains, and themselves gave place higher up to dark,
frowning precipices, vast walls of living rock, rising thousands
of feet sheer upwards, and ending in the mighty peaks
which stood like eternal sentinels guarding this enchanted
realm.</p>
<p class="calibre3">If she had had her will, she would have gazed for ever upon
this delightful scene; but the spirit of the dream was not to be
controlled, and it faded from her sight just as the picture of
death and desolation had done. As it faded away, Alan, who
had now come back to her side, laid his hand upon her shoulder,
and, looking at her with mournful eyes, said wearily—</p>
<p class="calibre3">“That was your first and last glimpse of heaven. Now
comes the judgment!”</p>
<p class="calibre3">As he spoke, the air-ship soared upwards again, and was
instantly enveloped in a cloud of impenetrable darkness. She<span id="pgepubid00072" title="[59]"><a id="Page_59" title="[59]"></a></span>
sped on and on in utter silence through the gloom, which was
so dense that it seemed to cast the rays of the ship’s electric
lights back upon her as she floated amidst it. Presently the
deathlike silence was broken by a low, weird sound, that
seemed like a wail of universal agony rising up from the earth
beneath.</p>
<p class="calibre3">Then, far ahead and high up in the sky, appeared a faint
light, which grew and brightened until the darkness melted
away before it; and Olga saw the air-ship floating near enough
to the earth for her to see that all its vegetation was withered
and yellow, and the beds of its streams almost dry, with only
little, thin rivulets trickling sluggishly along them.</p>
<p class="calibre3">Millions of people seemed wandering listlessly and aimlessly
about the streets of the cities and the parched fields of the
open country, ever and anon stretching their hands as though
in appeal up to the dark, moonless sky, in which the fearful
shape of light and fiery mist was growing every moment
brighter and vaster.</p>
<p class="calibre3">It grew and grew until it arched half the horizon with its
tremendous curve; and then out of the midst of it came a
huge, dazzling globe of fire, from the rim of which shot forth
great flames of every colour, some of which seemed to descend
to the surface of the earth like long fiery tongues that licked up
the seething lakes in wreathing clouds of steam, which hissed
and roared as they rose like ascending cataracts.</p>
<p class="calibre3">She looked down between them at the earth. The myriads
of figures were there still, but now they lay prone and lifeless
on the ground, as though the last agony of mankind were past.
The light of the blazing globe grew more and more dazzling,
and the heat more and more intense. The speed of the air-ship
slackened visibly, although the wings and propellers were
working at their utmost speed, and it was falling rapidly, as
though there was no longer any air to support it.</p>
<p class="calibre3">She gasped for breath in the choking, burning atmosphere
of the deck chamber, and then a swift, vivid wave of light
seemed to sweep through her brain, and she woke with a
choking gasp of terror, with the chimes of her watch ringing<span id="pgepubid00073" title="[60]"><a id="Page_60" title="[60]"></a></span>
sweetly in her ears, telling her that the vision had been but a
dream of a night that had passed.</p>
<p class="calibre3">Wide awake in an instant, she got out of bed and turned
on the electric lamp. As the room had been perfectly warmed
all night by the electric conduction-stoves, which were then
in almost universal use, she only stopped to throw a fur-lined
cloak round her shoulders before she went to remove the cap
of the crucible.</p>
<p class="calibre3">She peered anxiously into the vessel, and saw about two
fluid ounces of a dark, glittering liquid, from the surface of
which the light of the lamp was reflected as though from a
mirror. With hands that trembled slightly, in spite of the
great effort she made to keep her nerves in check, she poured
the precious fluid into one of the glass measures that she had
used the night before.</p>
<p class="calibre3">Seen through the glass, its colour was a deep, brilliant blue,
and, like the white liquid first prepared, shone as though with
an inherent, light-giving power of its own. She held it up
admiringly to the light, and said to herself, with the same cruel
smile that had curved her lips when she had contemplated the
other fluid—</p>
<p class="calibre3">“How beautiful it is! It might be made of sapphires
dissolved in some potent essence. In reality, it is an elixir
capable of dissolving the souls of men. Ah, my proud Masters
of the World, we shall soon see how much your boasted powers
avail you against this and a woman’s wit and hatred!</p>
<p class="calibre3">“And you, my splendid Alan, before to-morrow night you
shall be at my feet! Two drops of this, and that proud, strong
soul of yours shall melt away like a snowflake under warm
rain, and you shall be my slave and do my bidding, and never
know that you are not as free as you are now.</p>
<p class="calibre3">“The days have gone by when men sought the Elixir of Life,
but Paul Romanoff sought and found the Elixir of Death,—death
of the body or of the soul, as the possessor of it shall will; and he
is gone, and I, alone of all the children of men, possess it!”<a id="FNanchor_3_3"></a><span class="fnanchor" href="#/Text/Section0039#Footnote_3_3" title="Link target outside of Sample">[3]</span></p>
<p class="calibre3"><span id="pgepubid00074" title="[61]"><a id="Page_61" title="[61]"></a></span></p>
<p class="calibre3">She set the measure down on the table, and took out of
her valise a similar little flask to the one which held the white
liquid. In this she carefully poured the contents of the
measure, screwed the cap on as before, and hung it with the
other on the chain round her neck. Then, woman-like, she
turned to the mirror, threw back her cloak a little, and gazed
at the reflection of the two flasks, which shone like two great
gems upon her white skin.</p>
<p class="calibre3">“There is such a necklace as woman never wore before,
since woman first delighted in gems,—a necklace that all the
jewels in the world could not buy. How pretty they look!”</p>
<p class="calibre3">So saying, she turned away from the mirror and carefully
put away all traces of the work she had been engaged in, then
she threw off her cloak and turned the lamp out and got into
bed again, to wait until the attendant called her at eight
o’clock as she had directed.</p>
<p class="calibre3">She did not go to sleep again, but lay with wide-open eyes
looking at the darkness, and conjuring out of it visions of love
and war, and the world-wide empire which she believed to be
now almost within her grasp. In all these visions, two figures
stood out prominently—those of Serge and Alan, her lover
that had been and the lover that was to be,—if only the elixir
did its work as its discoverer had said it would.</p>
<p class="calibre3">As such thoughts as these passed through her brain, a new
and perhaps a nobler conception of her mission of revenge
took possession of her. In the past, Natasha had won the love
of the man whose genius had made possible, nay, irresistible,
the triumph of that revolution which had subverted the throne
of her ancestors, and sent the last of the Tsars of Russia to die
like a felon in chains amidst the snows of Siberia.</p>
<p class="calibre3">What more magnificent vengeance could she, the last
surviving daughter of the Romanoffs, win than the enslavement
of the man descended not only from Natasha and<span id="pgepubid00075" title="[62]"><a id="Page_62" title="[62]"></a></span>
Richard Arnold, but also from that Alan Tremayne whose
name he bore, and who, as first President of the Anglo-Saxon
Federation, had ensured the victory of the Western races over
the Eastern?</p>
<p class="calibre3">The empire of freedom and peace, which Richard Arnold
had won for Natasha’s sake, this son of the line of Natas
should convert, at her bidding, into an empire such as she
longed to rule over,—an empire in which men should be her
slaves and women her handmaidens. For her sake the wave
of Destiny should flow back again; she would be the Semiramis
of a new despotism.</p>
<p class="calibre3">What was the freedom or the happiness of the mass of
mankind to her? If she could raise herself above them, and
put her foot upon their necks, why should she not do so? By
force the leaders of the Terror had overthrown the despotisms
of the Old World; why should not she employ the self-same
force to seat herself, with the man she loved in spite of
all her hereditary hatred, upon the throne of the world, and
reign with him in that glorious land whose beauties had been
revealed to her in the vision which surely had been something
more than a dream?</p>
<p class="calibre3">Thus thinking and dreaming, and illumining the darkness
with her own visions of glories to come, she lay in a kind of
ecstasy, until a knock at the door warned her that the time
for dreaming had passed and the hour for action had arrived.</p>
<p class="calibre3">A brief half-hour sufficed for her toilet, and she entered
the room of the hotel, in which Serge was awaiting her, dressed
to perfection in her plain, clinging robe of royal purple, and
self-composed as though she had passed the night in the most
innocent and dreamless of slumbers. She submitted to his
greeting kiss with as good a grace as possible, and yet with an
inward shrinking which almost amounted to loathing, born of
the visions which were still floating in her mind.</p>
<p class="calibre3">She shuddered almost invisibly as he released her from his
embrace, and then the bright blood rose to her cheeks, and a
sudden light shone in her eyes, as the thought possessed her, that
not many hours would pass before a far nobler lover would<span id="pgepubid00076" title="[63]"><a id="Page_63" title="[63]"></a></span>
take her in his arms, and would press sweeter kisses upon her
lips,—the lips which had sworn fealty and devotion to the
enemies of his race.</p>
<p class="calibre3">Serge, with the true egotism of the lover, took the blush to
himself, and said, with a laugh of boyish frankness—</p>
<p class="calibre3">“Travelling and Russian air seem to agree with your
Majesty. Evidently you have slept well your first night on
Russian soil. I was half afraid that what happened yesterday,
and your conversation with that golden-winged braggart from
Aeria, would have sufficiently disturbed you to give you a more
or less sleepless night, but you look as fresh and as lovely as
though you had slept in the most perfect peace at home.”</p>
<p class="calibre3">The anger that these unthinking words awoke in her soul,
brought back the bright flush to Olga’s cheeks and the light
into her eyes, and again Serge mistook the sign, as indeed he
might well have done; and so he entirely mistook the meaning
of her words when she replied, with a laugh, of the true
significance of which he had not the remotest conception—</p>
<p class="calibre3">“On the contrary, how was it possible that I could have
anything but the sweetest sleep and the most pleasant dreams,
after such a delightful journey and the making of such pleasant
acquaintances? Do you not think the Fates have favoured us
beyond our wildest expectations, in thus bringing our enemies
so unconsciously across our path at the very outset of our
campaign against them?</p>
<p class="calibre3">“But really, these Aerians are delightful fellows. No,
don’t frown at me like that, because you know as well as I
do, that in that chivalrous good-nature of theirs lies our best
hope of success.”</p>
<p class="calibre3">As she spoke she went up to him, and laid her two hands
upon his shoulder, and went on looking up into his eyes with
a seductive softness in hers.</p>
<p class="calibre3">“I am afraid I made you terribly jealous yesterday; but
really, Serge, you must remember that in diplomacy, and
diplomacy alone, lies our only chance of advantage in the
circumstances which the kindly Fates appear to have specially
created for our benefit.</p>
<p class="calibre3"><span id="pgepubid00077" title="[64]"><a id="Page_64" title="[64]"></a></span></p>
<p class="calibre3">“The time for you to act will come later on, and when it
comes, I know you will acquit yourself like the true Romanoff
that you are; but for the present—well, you know these
Aerians are men, and where diplomacy alone is in the question,
it is better that a woman should deal with them. You will
trust me for the present,—won’t you, Serge?”</p>
<p class="calibre3">For all answer, he took her face between his hands, put her
head back, and kissed her, saying as he released her—</p>
<p class="calibre3">“Yes, darling; I will trust you not only now, but for ever.
You are wiser than I am in these things. Do as you please;
I will obey.”</p>
<p class="calibre3">As he spoke, the door opened, and an attendant came in
with two little cups of coffee on a silver salver. He placed it
on the table, told them that breakfast would be ready for them
in the morning-room in ten minutes, and retired. As they
sipped their coffee, Olga said to Serge—</p>
<p class="calibre3">“Now, we shall meet our enemies at breakfast, and I want
you to be a great deal more cordial and friendly than you
were yesterday. Our own feelings concern ourselves alone,
but in our outward conduct we owe something to the sacred
cause which we both have at heart. You can imagine how
great a sacrifice I am making in my relations with those whom
I have been taught to hate from my cradle.</p>
<p class="calibre3">“I can see as well as you do, perhaps better, that this
future ruler of Aeria admires me in his own boyish way. If I
can bring myself to appear complaisant, surely it is not too
much to ask you to look upon it with indifference, or even
with interest,—a brotherly interest, you know; for you must
remember that he knows me only as your sister.</p>
<p class="calibre3">“Now, I want you to ask them to come and have breakfast
with us at our table, and to exert yourself to appear agreeable
to them, even as I shall; and above all things, promise me that
you will fall in with any suggestions that I may make as
regards our trip in this wonderful air-ship which we are to
make to-morrow.</p>
<p class="calibre3">“There is no time now to explain to you what I mean, but
I swear to you, by the blood that flows in both our veins, that<span id="pgepubid00078" title="[65]"><a id="Page_65" title="[65]"></a></span>
if I can only carry through, without any let or hindrance, the
plans that I have already formed—that before forty-eight
hours have passed that air-ship shall no longer be under Alan
Arnoldson’s command.”</p>
<p class="calibre3">He looked at her for a moment with almost incredulous
admiration. She returned his inquiring glance with a steady,
unwavering gaze, which made suspicion impossible. All his
life he had grown up to look upon her as sharing with him the
one hope that was left of restoring the ancient fortunes of their
family. More than this they had been lovers ever since either
of them knew the meaning of love.</p>
<p class="calibre3">How then could he have dreamt that behind so fair an
appearance lay as dark and treacherous a design as the brain
of an ambitious woman had ever conceived? Intoxicated by
her beauty and the memory of his lifelong love, he took a
couple of steps towards her, took her unresisting into his arms
again, and said passionately—</p>
<p class="calibre3">“Give me another kiss, darling, and on your lips I will
swear to trust you always and do your bidding even to the
death.”</p>
<p class="calibre3">She returned his kiss with a passion so admirably simulated
that his resolve was thrice strengthened by it, and then she
released herself gently from his embrace, saying—</p>
<p class="calibre3">“Even so, unto the death if needs be,—as I shall serve our
sacred cause to the end, cost what it may! Come, it is time
that we went down to breakfast.”</p>
<div class="figcenter3">
<img alt="" class="calibre13" id="id-2672309904694213930" src="Images/img0009.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0011.vue?47f58ccd